import { clsx } from 'clsx'
import { BarChart3, MessageSquare, Database, Upload, FileText, ShieldCheck } from 'lucide-react'

export type Tab = 'overview' | 'database' | 'ingestion' | 'reports' | 'feedback' | 'standards-access'

interface TabNavProps {
  activeTab: Tab
  onChange: (tab: Tab) => void
}

const tabs: { id: Tab; label: string; icon: typeof BarChart3 }[] = [
  { id: 'overview',         label: 'Overview',         icon: BarChart3    },
  { id: 'database',         label: 'Database',         icon: Database     },
  { id: 'ingestion',        label: 'Ingestion',        icon: Upload       },
  { id: 'reports',          label: 'Reports',          icon: FileText     },
  { id: 'feedback',         label: 'Feedback',         icon: MessageSquare },
  { id: 'standards-access', label: 'Standards Access', icon: ShieldCheck  },
]

export default function TabNav({ activeTab, onChange }: TabNavProps) {
  return (
    <div className="border-b border-gray-200 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <nav className="flex gap-6">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onChange(tab.id)}
              className={clsx(
                'flex items-center gap-2 py-3 px-1 text-sm font-medium border-b-2 transition-colors',
                activeTab === tab.id
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
              )}
            >
              <tab.icon className="w-4 h-4" />
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  )
}
